
import { useState } from 'react';

export default function LearnershipSection() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeSETA, setActiveSETA] = useState('wrseta');

  const setas = [
    { id: 'wrseta', name: 'W&RSETA', fullName: 'Wholesale and Retail SETA' },
    { id: 'teta', name: 'TETA', fullName: 'Transport Education and Training Authority' },
    { id: 'agriseta', name: 'AgriSETA', fullName: 'Agriculture Sector Education and Training Authority' },
    { id: 'services', name: 'Services SETA', fullName: 'Services Sector Education and Training Authority' }
  ];

  const programmes = {
    wrseta: [
      {
        name: 'National Certificate: Wholesale and Retail Operations',
        saqaId: '58206',
        learnershipCode: '27Q270014551202',
        credits: '120 Credits',
        enrolmentEndDate: '2026-06-30',
        description: 'National Certificate: Wholesale and Retail Operations'
      },
      {
        name: 'National Certificate: Informal and Small Business Practice',
        saqaId: '58308',
        learnershipCode: '27Q270026291203',
        credits: '120 Credits',
        enrolmentEndDate: '2024-06-30',
        description: 'National Certificate: Informal and Small Business Practice'
      }
    ],
    teta: [
      {
        name: 'National Certificate Professional Driving',
        saqaId: '50285',
        nqfLevel: 'Level 03',
        credits: '122 Credits',
        description: 'National Certificate Professional Driving'
      }
    ],
    agriseta: [
      {
        name: 'National Certificate: Animal Production',
        saqaId: '48970',
        nqfLevel: 'NQF 1',
        credits: '120 Credits',
        description: 'National Certificate: Animal Production'
      },
      {
        name: 'National Certificate: Animal Production',
        saqaId: '48976',
        nqfLevel: 'NQF 2',
        credits: '120 Credits',
        description: 'National Certificate: Animal Production'
      },
      {
        name: 'National Certificate: Plant Production',
        saqaId: '48972',
        nqfLevel: 'NQF 1',
        credits: '120 Credits',
        description: 'National Certificate: Plant Production'
      },
      {
        name: 'National Certificate: Plant Production',
        saqaId: '48975',
        nqfLevel: 'NQF 2',
        credits: '120 Credits',
        description: 'National Certificate: Plant Production'
      }
    ],
    services: [
      {
        name: 'Further Education and Training Certificate: Generic Management',
        saqaId: '57712 LP58344',
        nqfLevel: 'NQF 04',
        credits: '150 Credits',
        description: 'Further Education and Training Certificate: Generic Management'
      },
      {
        name: 'Further Education and Training Certificate: Generic Management',
        saqaId: '57712 LP74630',
        nqfLevel: 'NQF 04',
        credits: '150 Credits',
        description: 'Further Education and Training Certificate: Generic Management'
      },
      {
        name: 'Further Education and Training Certificate: New Venture Creation',
        nqfLevel: 'NQF 04',
        credits: '149 Credits',
        description: 'Further Education and Training Certificate: New Venture Creation'
      },
      {
        name: 'National Certificate: New Venture Creations',
        nqfLevel: 'NQF 02',
        credits: '138 Credits',
        description: 'National Certificate: New Venture Creations'
      },
      {
        name: 'Domestic Services',
        nqfLevel: 'NQF 01',
        credits: '141 Credits',
        description: 'Domestic Services'
      }
    ]
  };

  return (
    <div className="mb-12">
      <div 
        className="bg-white rounded-lg shadow-md border border-gray-200 cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="p-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-[#1A1A1A] mb-2">
              Learnerships
            </h2>
            <p className="text-gray-600">
              Structured learning programmes combining theoretical and practical training
            </p>
          </div>
          <i className={`ri-arrow-${isExpanded ? 'up' : 'down'}-s-line text-2xl text-[#2D7F3E]`}></i>
        </div>
      </div>

      {isExpanded && (
        <div className="mt-4 bg-white rounded-lg shadow-md border border-gray-200">
          <div className="p-6">
            {/* SETA Tabs */}
            <div className="flex flex-wrap gap-2 mb-6">
              {setas.map((seta) => (
                <button
                  key={seta.id}
                  onClick={() => setActiveSETA(seta.id)}
                  className={`px-4 py-2 rounded-full font-medium transition-all duration-200 whitespace-nowrap ${
                    activeSETA === seta.id
                      ? 'bg-[#2D7F3E] text-white'
                      : 'bg-[#F5F5F5] text-[#1A1A1A] hover:bg-[#E0E0E0]'
                  }`}
                >
                  {seta.name}
                </button>
              ))}
            </div>

            {/* Programme Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {programmes[activeSETA as keyof typeof programmes].map((programme, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                  <h3 className="text-lg font-semibold text-[#1A1A1A] mb-3">
                    {programme.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    {programme.description}
                  </p>
                  <div className="space-y-2 text-sm mb-4">
                    {programme.nqfLevel && (
                      <div className="flex justify-between">
                        <span className="text-gray-500">Level:</span>
                        <span className="font-medium">{programme.nqfLevel}</span>
                      </div>
                    )}
                    {programme.saqaId && (
                      <div className="flex justify-between gap-4">
                        <span className="text-gray-500">SAQA ID:</span>
                        <span className="font-medium text-right">{programme.saqaId}</span>
                      </div>
                    )}
                    {programme.learnershipCode && (
                      <div className="flex justify-between gap-4">
                        <span className="text-gray-500">Learnership Code:</span>
                        <span className="font-medium text-right break-words">{programme.learnershipCode}</span>
                      </div>
                    )}
                    <div className="flex justify-between">
                      <span className="text-gray-500">Credits:</span>
                      <span className="font-medium">{programme.credits}</span>
                    </div>
                    {programme.duration && (
                      <div className="flex justify-between">
                        <span className="text-gray-500">Duration:</span>
                        <span className="font-medium">{programme.duration}</span>
                      </div>
                    )}
                    {programme.enrolmentEndDate && (
                      <div className="flex justify-between gap-4">
                        <span className="text-gray-500">Enrolment end date:</span>
                        <span className="font-medium text-right">{programme.enrolmentEndDate}</span>
                      </div>
                    )}
                  </div>
                  {programme.unitStandards && (
                    <div className="mb-4">
                      <span className="text-xs text-gray-500">Unit Standards:</span>
                      <div className="flex flex-wrap gap-1 mt-1">
                        {programme.unitStandards.map((standard, idx) => (
                          <span key={idx} className="bg-[#F5F5F5] text-xs px-2 py-1 rounded">
                            {standard}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                  <div className="flex gap-2">
                    <button className="flex-1 btn btn-primary btn-sm">
                      Apply Now
                    </button>
                    <button className="px-4 py-2 border border-[#2D7F3E] text-[#2D7F3E] rounded-lg hover:bg-[#2D7F3E] hover:text-white transition-colors text-sm font-medium whitespace-nowrap">
                      <i className="ri-download-line mr-1"></i>
                      Info Sheet
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
